import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Alert,
} from '@mui/material';
import { ApiKeySummary } from '../services/api';

interface Props {
  target: ApiKeySummary | null;
  onCancel: () => void;
  onConfirm: () => void;
}

const ConfirmRevokeDialog: React.FC<Props> = ({ target, onCancel, onConfirm }) => {
  return (
    <Dialog open={!!target} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Revoke API key</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Revoke <strong>{target?.keyName}</strong>
          {target?.keyPrefix ? ` (${target.keyPrefix}…)` : null}? Any integrator or
          service using this key will start receiving 401 immediately.
        </DialogContentText>
        <Alert severity="warning">This action cannot be undone.</Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button color="error" variant="contained" onClick={onConfirm}>
          Revoke
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmRevokeDialog;
